<template>
    <div
        class="scrollbar-thin scrollbar-thumb-blue-700 scrollbar-track-blue-300
		scrollbar-thumb-rounded-full scrollbar-track-rounded-full overflow-y-auto fixed z-20 h-full border-r
		transition-all duration-200 sm:relative sm:w-2/12 bg-white text-gray-800 border-gray-300">
        <div class="block py-3 px-4 sm:hidden">
            <button class="p-2 bg-white rounded-full" @click="$emit('hide-sidebar')">
                <close-icon class="w-6 h-6 text-gray-400"></close-icon>
            </button>
        </div>
        <div
            class="flex sticky top-0 justify-center py-3 px-4 border-b border-gray-300 bg-white">
            <a class="hover:border-blue-500 h-10 rounded-full sm:w-36 w-36 my-4" href="/">
                <support-logo class="w-full h-full"></support-logo>
            </a>
        </div>
        <nav class="text-sm capitalize my-8">
            <menu-primary :items="menus"></menu-primary>
        </nav>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import ChevronDown from "@js/icons/ChevronDown.vue";
import ChevronUp from "@js/icons/ChevronUp.vue";
import CloseIcon from '@js/icons/X.vue';
import SupportLogo from "@js/logo/SupportLogo.vue";
import MenuPrimary from "./MenuPrimary.vue";
import _ from 'lodash';  // Load lodash to perform deep clone

const sidebarMenuOpt = sidebarMenu;

const menus = ref([...sidebarMenuOpt]);

</script>

<style scoped>
/* Add any scoped styles here */
</style>
